module.exports = __webpack_public_path__ + "static/media/dominos.adf963cc.svg";